import { arrayOf, shape, string, array } from 'prop-types';

// This proptype is reused in a few components so I keep it here
export const sitemap = arrayOf(shape({ url: string, name: string, children: array }));
